import React from 'react';
import { Router, Switch, Route } from 'react-router';
import { Redirect } from 'react-router-dom';
import { createBrowserHistory } from 'history';
import SharedSample from "./SharedSample";

class App extends React.Component {
  render(props) {
    return (<Router key='sharingLander_router' history={createBrowserHistory()}>
      <Switch key='sharingLander_router_switch'>
        <Route key='sharingLander_router_switch_prayerRoute' path='*/prayers/:prayerId' render={(props) => {
          return <SharedSample key='sharingLander_router_switch_prayerRoute_sample' myKey='sharingLander_router_switch_prayerRoute_sample' {...props} usePublic={true} />
        }} />
        <Redirect key='sharingLander_router_switch_redirect' to='/' />
      </Switch>
    </Router>);
  }
}

export default App;